import { rem } from '@mantine/core'

import type { TextVariantBody, TextVariantConfig } from './Text.types'

export const TEXT_VARIANT_BODY: Record<TextVariantBody, TextVariantConfig> = {
  body_1: {
    color: 'var(--mantine-other-colors-black)',
    fw: 500,
    lh: rem(22),
    size: rem(16),
  },
  body_1_bold: {
    color: 'var(--mantine-other-colors-black)',
    fw: 700,
    lh: rem(22),
    size: rem(16),
  },
  body_1_grey: {
    color: 'var(--mantine-other-colors-dark-grey)',
    fw: 500,
    lh: rem(22),
    size: rem(16),
  },
  body_1_medium_green: {
    color: 'var(--mantine-other-colors-dark-green)',
    fw: 500,
    lh: rem(22),
    size: rem(16),
  },
  body_1_medium_purple: {
    color: 'var(--mantine-other-colors-purple)',
    fw: 500,
    lh: rem(22),
    size: rem(16),
  },
  body_1_semibold: {
    color: 'var(--mantine-other-colors-black)',
    fw: 600,
    lh: rem(22),
    size: rem(16),
  },
  body_1_semibold_green: {
    color: 'var(--mantine-other-colors-dark-green)',
    fw: 600,
    lh: rem(22),
    size: rem(16),
  },
  body_1_semibold_red: {
    color: 'var(--mantine-other-colors-red)',
    fw: 600,
    lh: rem(22),
    size: rem(16),
  },
  body_2: {
    color: 'var(--mantine-other-colors-dark-grey)',
    fw: 400,
    lh: rem(20),
    size: rem(14),
  },
  body_2_black: {
    color: 'var(--mantine-other-colors-black)',
    fw: 400,
    lh: rem(20),
    size: rem(14),
  },
  body_2_medium_black: {
    color: 'var(--mantine-other-colors-black)',
    fw: 500,
    lh: rem(20),
    size: rem(14),
  },
  body_2_medium_green: {
    color: 'var(--mantine-other-colors-primary-dark-green)',
    fw: 500,
    lh: rem(20),
    size: rem(14),
  },
  body_2_semibold_black: {
    color: 'var(--mantine-other-colors-black)',
    fw: 600,
    lh: rem(20),
    size: rem(14),
  },
  body_2_semibold_green: {
    color: 'var(--mantine-other-colors-primary-dark-green)',
    fw: 600,
    lh: rem(20),
    size: rem(14),
  },
  body_2_semibold_grey: {
    color: 'var(--mantine-other-colors-dark-grey)',
    fw: 600,
    lh: rem(20),
    size: rem(14),
  },
  body_3: {
    color: 'var(--mantine-other-colors-black)',
    fw: 600,
    lh: rem(20),
    size: rem(14),
  },
  body_3_red: {
    color: 'var(--mantine-other-colors-red)',
    fw: 600,
    lh: rem(20),
    size: rem(14),
  },
  body_4: {
    color: 'var(--mantine-other-colors-black)',
    fw: 400,
    lh: rem(20),
    size: rem(12),
  },
  body_4_gray: {
    color: 'var(--mantine-other-colors-dark-grey)',
    fw: 400,
    lh: rem(20),
    size: rem(12),
  },
  body_4_semibold: {
    color: 'var(--mantine-other-colors-black)',
    fw: 600,
    lh: rem(20),
    size: rem(12),
  },
}
